<template>

      <div class="rm" :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>{{registration_method.name}}</strong></p>
                <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">{{this.generateDescription(registration_method)}}</p>
              </label>
            </div>
          </div>
        </div>
        <div class="rm-form" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="LAST NAME" />
            </div>
            <div class="row mb-15">
              <div class="select-wrapper">
                <select v-model="form.room_number" class="input-text rounded">
                  <option disabled value="">Please select a room</option>
                  <option value="1">Suite 1</option>
                  <option value="2">Room 2</option>
                  <option value="3">Room 3</option>
                  <option value="4">Suite 4</option>
                  <option value="5">Room 5</option>
                  <option value="6">Room 6</option>
                  <option value="7">Suite 7</option>
                  <option value="8">Room 8</option>
                  <option value="9">Room 9</option>
                  <option value="11">The Residence</option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row mb-15 p-rel">
            <input v-model="access_code" class="input-text rounded" type="text" placeholder="Access Code" />
            <span v-if="!access_code_valid" class="error-text">{{access_code_error_text}}</span>
          </div>
          <div class="mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded submit-btn" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">CONNECT</button>
          </div>
          <p class="text-center text-14 mb-0 terms">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link"><br>Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      clicked: false,
      form: {
        last_name: '',
        room_number: '',
        email_address: '',
      },
    }
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.access_code){
        this.access_code_valid = false;
        return;
      }
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.access_code;
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style scoped>
.mb-15 {margin-bottom: 25px;}

select, select option {
  text-transform:uppercase;
 -webkit-appearance: none;
  appearance: none;
}

select option {padding: 20px;}

.select-wrapper {
  position: relative;
}

.select-wrapper::after {
  content: "▼";
  font-size: .5rem;
  top: 35px;
  right: 20px;
  position: absolute;
  color: white;
}
</style>
